import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import * as types from "@/store/types";
import LoginPage from "@/views/auth/Login.vue";
import RecoverPage from "@/views/auth/Recover.vue";
import LayoutPage from "@/views/Layout.vue";
import { registerCoreModule } from "./modules/core";
import { registerActivitiesModule } from "./modules/activities";
import { registerEntitiesModule } from "./modules/entities";
import { registerUsersModule } from "./modules/users";
import { registerAdministrationModule } from "./modules/administration";
import { registerFeedbackModule } from "./modules/feedback";

Vue.use(VueRouter);

let routes: Array<RouteConfig> = [
  {
    path: "/",
    component: LayoutPage,
    beforeEnter(to, from, next) {
      if (window.localStorage.getItem(types.GLOBAL_USER_TOKEN)) {
        next();
      } else {
        next("/login");
      }
    },
    children: []
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    beforeEnter(to, from, next) {
      if (window.localStorage.getItem(types.GLOBAL_USER_TOKEN)) {
        next("/dashboard");
      } else {
        next();
      }
    }
  },
  {
    path: "/recover",
    name: "Recover",
    component: RecoverPage,
    beforeEnter(to, from, next) {
      if (window.localStorage.getItem(types.GLOBAL_USER_TOKEN)) {
        next("/dashboard");
      } else {
        next();
      }
    }
  },
  {
    path: "*",
    redirect: "/dashboard"
  }
];

routes = registerCoreModule(routes);
routes = registerActivitiesModule(routes);
routes = registerEntitiesModule(routes);
routes = registerUsersModule(routes);
routes = registerAdministrationModule(routes);
routes = registerFeedbackModule(routes);

export default routes;
